var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowleft(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 18,
    viewBox: "0 0 10 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "arrow-left.svg",
    clipPath: "url(#clip0_8_9798)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M0.623911 9.85863C0.156613 9.38442 0.156613 8.61558 0.623911 8.14137L7.80346 0.855657C8.27075 0.381448 9.02839 0.381448 9.49569 0.855657C9.96299 1.32987 9.96299 2.09871 9.49569 2.57292L3.16226 9L9.49569 15.4271C9.96299 15.9013 9.96299 16.6701 9.49569 17.1443C9.02839 17.6186 8.27075 17.6186 7.80346 17.1443L0.623911 9.85863Z",
    fill: "#0C4ACF"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_8_9798"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 10,
    height: 17,
    fill: "white",
    transform: "translate(0 0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowleft);
export default __webpack_public_path__ + "static/media/arrowleft.28191c902a001bddf552243a910dc531.svg";
export { ForwardRef as ReactComponent };